import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ContextMenuProvider } from './contexts/ContextMenuContext';
import Main from './Main';
import './App.css';

function App() {
    useEffect(() => {
        const saved = localStorage.getItem('bb-theme');
        if (saved === 'light') {
            document.documentElement.setAttribute('data-theme', 'light');
        }
    }, []);

    return (
        <BrowserRouter>
            <AuthProvider>
                <ContextMenuProvider>
                    <div className="App">
                        <Main />
                    </div>
                </ContextMenuProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
